/**
 * ResearchReport Component
 * Displays final research report with markdown support
 */

import React from 'react';
import { View, Text, StyleSheet, ScrollView } from 'react-native';
import { Colors } from '@/constants/colors';
import { MarkdownText } from '@components/common/MarkdownText';

interface ResearchReportProps {
  report: string;
  metadata?: {
    cost: number;
    duration: number;
    questionsCount: number;
    sourcesCount: number;
  };
}

export const ResearchReport: React.FC<ResearchReportProps> = ({ report, metadata }) => {
  return (
    <ScrollView style={styles.container} showsVerticalScrollIndicator={false}>
      {metadata && (
        <View style={styles.metadata}>
          <View style={styles.metadataRow}>
            <Text style={styles.metadataLabel}>Duration:</Text>
            <Text style={styles.metadataValue}>{metadata.duration.toFixed(1)}s</Text>
          </View>
          <View style={styles.metadataRow}>
            <Text style={styles.metadataLabel}>Cost:</Text>
            <Text style={styles.metadataValue}>${metadata.cost.toFixed(3)}</Text>
          </View>
          <View style={styles.metadataRow}>
            <Text style={styles.metadataLabel}>Sources:</Text>
            <Text style={styles.metadataValue}>{metadata.sourcesCount}</Text>
          </View>
          <View style={styles.metadataRow}>
            <Text style={styles.metadataLabel}>Questions:</Text>
            <Text style={styles.metadataValue}>{metadata.questionsCount}</Text>
          </View>
        </View>
      )}

      <View style={styles.report}>
        <MarkdownText text={report} />
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  metadata: {
    backgroundColor: Colors.background.secondary,
    borderRadius: 12,
    padding: 14,
    marginBottom: 16,
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 12,
  },
  metadataRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  metadataLabel: {
    fontSize: 13,
    color: Colors.text.tertiary,
    marginRight: 4,
  },
  metadataValue: {
    fontSize: 13,
    fontWeight: '600',
    color: Colors.text.primary,
  },
  report: {
    backgroundColor: Colors.background.secondary,
    borderRadius: 12,
    padding: 16,
  },
});
